import { Html, useProgress } from '@react-three/drei'
import React from 'react'
import { appleImg } from '../utils'

const Loader = () => {
  const { progress } = useProgress()

  return (
    <Html center>
      <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center backdrop-blur-sm bg-black/50 rounded-lg">
        <div className="flex flex-col items-center">
          <img src={appleImg} alt="logo" className="w-12 h-12 mb-4 animate-pulse opacity-80" />
          <div className="w-40 h-1 bg-gray-800 rounded-full relative overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full bg-white transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="mt-2 text-xs font-light text-gray-500">{Math.round(progress)}%</p>
        </div>
      </div>
    </Html>
  )
}

export default Loader